module.exports = __webpack_public_path__ + "static/MovieSphere-4cc30ede08a376205928ba6b7f2121df.png";